import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-description" }

import { markRaw, reactive, ref } from "vue";
  import Popup from "@/components/_partials/Popup.vue";
  import { LotCurrencyList } from "@/components/_partials/lot-info-popup";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LotCurrencyBtn',
  setup(__props) {

  const state = reactive({
    component: markRaw(LotCurrencyList)
  });

  const currencyPopup = ref<Popup>(null);

  const openPopup = () => {
    currencyPopup.value?.toggleComponent(state.component);
    currencyPopup.value?.open();
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: openPopup }, [
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(Popup, {
      title: "Change currency",
      class: "currency-modal",
      ref_key: "currencyPopup",
      ref: currencyPopup
    }, {
      "before-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(trans)("modals.currency_modal.description")), 1)
      ]),
      _: 1
    }, 512)
  ]))
}
}

})